import { render, staticRenderFns } from "./exhibition-tip.vue?vue&type=template&id=6abe5a2e&scoped=true&"
import script from "./exhibition-tip.vue?vue&type=script&lang=js&"
export * from "./exhibition-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe5a2e",
  null
  
)

export default component.exports